var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form-button',{staticClass:"proposals-approved-button",attrs:{"color":_vm.color,"href":_vm.parsed,"target":_vm.target,"size":"small"},nativeOn:{"click":function($event){$event.stopPropagation();}}},[_vm._v("\n  "+_vm._s(_vm.text)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }